export default {
  default: {
    attachmentDeleted: 'Attachment Deleted ',
    attachmentUpdated: 'Attachment Updated',
    fileLibraryCreated: 'File Library Created',
    fileLibraryDeleted: 'File Library Deleted ',
    fileLibraryUpdated: 'File Library Updated',
  },
}
